import { getCycleFromClassrooms } from '../EventModal/getCycleFromClassrooms';
import getFirstTagOfClassrooms from 'utils/getFirstTagOfClassrooms';
import { Classroom } from 'types/classroom';
import { CJEvent, CJEventType } from 'types/event';

export function emptySeance({
  start,
  end,
  classrooms,
  type,
  title,
}: {
  start: Date;
  end: Date;
  classrooms: Classroom[];
  type: CJEventType;
  title?: string;
}): Omit<CJEvent, 'id'> {
  return {
    createdAt: new Date(),
    end: end,
    status: 'open',
    start: start,
    bo: {
      cycle: getCycleFromClassrooms(classrooms),
      domaine: [],
      matiere: [],
      competence: [],
      goals: [],
    },
    title: title || '',
    flow: '',
    type,
    classroomIds: classrooms.map(c => c.id),
    order: 1,
    tag: getFirstTagOfClassrooms(classrooms),
    materials: [],
    attachments: [],
    linkedFichesDePrep: [],
    customFields: [],
    ateliers: [],
  };
}
